@import "../../global/normalize.css";

:host {
  display: block;
}

.heading {
  --ic-typography-color: var(--ic-data-list-text-heading);
}

.rows {
  display: flex;
  flex-direction: column;
  gap: var(--ic-space-md);
}

:host(.ic-data-list-small) .rows {
  gap: var(--ic-space-xs);
}

.divider {
  margin-top: var(--ic-space-lg);
  margin-bottom: var(--ic-space-md);
  height: var(--ic-border-width);
  background-color: var(--ic-data-list-keyline-heading);
}

:host(.ic-data-list-small) .divider {
  margin-top: var(--ic-space-sm);
  margin-bottom: var(--ic-space-xs);
}

@media (forced-colors: active) {
  .divider {
    background-color: canvastext;
  }
}
